import { useContext } from 'react'
import { ITraitLayout } from 'types'
import { addLayoutTag } from '../../../utils/helpers'
import { parsePadding } from '../../../utils/layoutUtils'
import { getFilledTraitMap } from '../../../utils/traitUtils'
import { SessionContext, useExplorerConfig } from '../../providers'
import { SMarkdown } from '../../scaled'

export default function TraitLayout({
  style,
  title,
  traitKey,
  valueIndex,
}: Omit<ITraitLayout, 'type'>) {
  const { templateDocs } = useExplorerConfig()
  const { getLanguageValue } = useContext(SessionContext)
  const traits = getFilledTraitMap(templateDocs)
  const trait = traits[traitKey]
  if (!trait) return null

  const value = trait.values.find((_, i) => i === valueIndex)
  if (!value) return null

  const { description, subtitle } = value
  if (!description) return null

  let text = getLanguageValue(description)
  if (subtitle) text = `## **${getLanguageValue(subtitle)}**\n${text}`

  const padding = parsePadding({ style, title })

  //@ts-ignore
  return <SMarkdown containerProps={{ ...padding, ...addLayoutTag('trait') }} value={text} />
}
